import React from 'react';

import styled from 'styled-components';
import { LTTestStatusLabel } from '@lambdatestincprivate/lt-components';

import PrimaryHeader from './PrimaryHeader';
import SecondaryHeader from './SecondaryHeader';

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  gap: 16px;
`;

const CompactContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  width: 100%;
  gap: 24px;
`;

const CompactActions = styled.div`
  margin-left: auto;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
`;

const LTTestHeader = ({
  testDetail,
  secondaryHeaderData = [],
  middleContent,
  compact = false,
  ...rest
}) => {
  if (compact) {
    const { status = '' } = testDetail || {};
    return (
      <CompactContainer id="testHeader" data-testid="test-header-compact">
        <LTTestStatusLabel
          iconSrc={rest.statusIconSrc}
          status={status}
          width="20"
          height="20"
        />
        <SecondaryHeader secondaryHeaderData={secondaryHeaderData} compact />
        {rest.headerActions && (
          <CompactActions>{rest.headerActions}</CompactActions>
        )}
      </CompactContainer>
    );
  }

  return (
    <Container id="testHeader" data-testid="test-header">
      <PrimaryHeader testDetail={testDetail} {...rest} />
      {middleContent}
      <SecondaryHeader secondaryHeaderData={secondaryHeaderData} />
    </Container>
  );
};

export default LTTestHeader;
